import { render, staticRenderFns } from "./CustomerMainInfo.vue?vue&type=template&id=7fd2401a"
import script from "./CustomerMainInfo.vue?vue&type=script&lang=ts"
export * from "./CustomerMainInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports